import { TFilters } from "@common/components/ResidenceGeneric/Filters";
import { create } from "zustand";

export type SortConfig = {
  field: string | null;
  direction: string;
};

const initialSortConfig: SortConfig = {
  field: null,
  direction: "ascending",
};

export const initialFilters: TFilters = {
  topologies: [],
  floor: [0, 0],
  price: [0, 0], // Both are updated dynamically in residences3D updated dynamically
  beds: [],
};

interface InitialState {
  navigation: "string" | null;
  setNavigation: (navigation: "string" | null) => void;
  residencePopup: boolean;
  compareMode: boolean;
  compareSection: string;
  selectedRows: any[];
  orbitIndex: number;
  contentIndex: number;
  selectedUnit: any;
  imageOverlay: string;
  residenceStyleIndex: number;
  residenceViewFullscreen: boolean;
  galleryImagesIndex: number;
  setContentIndex: (index: number) => void;
  syncState: (stateToUpdate: any) => void;
  contentControls: any;
  filteredUnits: any;
  sortConfig: SortConfig;
  filters: TFilters;
  tableVisible: boolean;
  aboutIndex: number;
  categoriesVisible: boolean;
  splashPage: boolean;
  controlsVisible: boolean;
  galleryOverlay: boolean;
}

export const useStore = create<InitialState>((set) => ({
  navigation: null,
  setNavigation: (navigation: "string" | null) => {
    set({ navigation });
  },

  orbitIndex: 0,
  filteredUnits: null,
  contentControls: {
    index: 0,
    categories: [],
  },
  selectedUnit: null,
  galleryImagesIndex: null,
  residenceStyleIndex: 0,
  residenceViewFullscreen: false,
  sortConfig: initialSortConfig,
  filters: initialFilters,
  imageOverlay: null,
  contentIndex: 0,
  compareMode: false,
  compareSection: "floorplan",
  selectedRows: [],
  residencePopup: false,
  tableVisible: false,
  aboutIndex: 0,
  categoriesVisible: false,
  splashPage: true,
  controlsVisible: false,
  galleryOverlay: false,

  setContentIndex: (index) => {
    set({ contentIndex: index });
  },

  syncState: (stateToUpdate) => {
    set({ ...stateToUpdate });
  },
}));
